import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
    rootContainer: {
        width: '100%',
        height: '100%',
        position: 'relative',
        background: 'white',
        overflow: 'hidden',
        borderRadius: 30,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        fontFamily: 'Nunito, Poppins, Open Sans, Inter, sans-serif',
        padding: '20px',
        boxSizing: 'border-box',
    },
    successIcon: {
        width: 62,
        height: 62,
        background: 'linear-gradient(90deg, #C084FC 0%, #724F96 100%)',
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: 40,
        position: 'relative',
    },
    checkmark: {
        width: 29.13,
        height: 22.60,
        background: 'white',
        mask: 'url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 24 24\' fill=\'none\' stroke=\'currentColor\' stroke-width=\'3\' stroke-linecap=\'round\' stroke-linejoin=\'round\'%3E%3Cpolyline points=\'20,6 9,17 4,12\'/%3E%3C/svg%3E") no-repeat center',
        maskSize: 'contain',
    },
    successTitle: {
        color: '#C084FC',
        fontSize: 18.32,
        fontFamily: 'Poppins',
        fontWeight: '600',
        lineHeight: '18.32px',
        wordWrap: 'break-word',
        textAlign: 'center',
        marginBottom: 20,
    },
    successMessage: {
        width: '100%',
        maxWidth: 310,
        textAlign: 'center',
        fontSize: 18,
        fontFamily: 'Poppins',
        fontWeight: '500',
        lineHeight: '24px',
        wordWrap: 'break-word',
    },
    normalText: {
        color: '#B6B6B6',
    },
    highlightText: {
        color: '#68B9FF',
        cursor: 'pointer',
        textDecoration: 'underline',
        '&:hover': {
            color: '#4A9EFF',
        },
    },
}));

const PasswordSuccess = () => {
    const classes = useStyles();
    const navigate = useNavigate();
    const location = useLocation();
    
    const { userData, role } = location.state || {};

    const handlePersonalDetails = () => {
        navigate('/personal-details', {
            state: {
                userData,
                role
            }
        });
    };

    return (
        <div className={classes.rootContainer}>
            <div className={classes.successIcon}>
                <div className={classes.checkmark} />
            </div>
            
            <div className={classes.successTitle}>
                Your password has been created.
            </div>
            
            <div className={classes.successMessage}>
                <span className={classes.normalText}>Please submit your </span>
                <span className={classes.highlightText} onClick={handlePersonalDetails}>personal details</span>
                <span className={classes.normalText}> for the verification.</span>
            </div>
        </div>
    );
};

export default PasswordSuccess;
